<bb-progress-tracker-container
  [eventList]="eventListData | async"
  [progressTrackerTemplate]="progressTrackerTemplate"
  [progressTrackerItemTemplate]="progressTrackerItemTemplate"
  [progressTrackerHeaderTemplate]="progressTrackerHeaderTemplate"
  [(show)]="isOpen"
>
</bb-progress-tracker-container>
